import { UserManager, WebStorageStateStore } from "oidc-client-ts";

const settings = {
  authority: import.meta.env.VITE_AUTHORITY,
  client_id: "Skynet",
  redirect_uri: `${import.meta.env.VITE_HOST}/callback`,

  response_type: "code",
  response_mode: "query" as const,
  loadUserInfo: true,
  automaticSilentRenew: true,
  revokeTokensOnSignout: false,

  post_logout_redirect_uri: `${import.meta.env.VITE_HOST}/signed-out`,
  silent_redirect_uri: `${import.meta.env.VITE_HOST}/silent`,

  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

export const userManager = new UserManager(settings);
